import React from 'react';

export default function ErrorMessage({ message, onRetry }) {
  return (
    <div className="mc-border rounded-xl p-8 bg-mc-card text-center">
      <span className="text-4xl">💀</span>
      <p className="text-mc-redstone mt-4 font-semibold">Error</p>
      <p className="text-mc-muted text-sm mt-2">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-2 bg-mc-accent/20 text-mc-accent rounded-lg hover:bg-mc-accent/30 transition-colors text-sm"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}
